import type { ElementType } from "react";
import moment from "moment/moment";
import {
  IconAlertCircle,
  IconCertificate,
  IconBuildingBank,
  IconChecklist,
  IconFlame,
  IconLogout,
  IconShieldCheck,
  IconSignature,
  IconTrendingUp,
} from "@tabler/icons-react";
import type { PriorityActionType } from "../../../models/priorityAction";

export interface PriorityActionCategory {
  key: string;
  label: string;
}

export const CATEGORIES: Record<string, PriorityActionCategory> = {
  fin_de_bail: { key: "fin_de_bail", label: "Fin de bail" },
  paiements: { key: "paiements", label: "Paiements" },
  documents: { key: "documents", label: "Documents" },
  revisions: { key: "revisions", label: "Révisions de loyer" },
  banques: { key: "banques", label: "Banques" },
  taches: { key: "taches", label: "Mes tâches" },
};

export const CATEGORY_ORDER = [
  "fin_de_bail",
  "paiements",
  "documents",
  "revisions",
  "banques",
  "taches",
];

export const TYPE_CONFIG: Record<
  PriorityActionType,
  { category: PriorityActionCategory; icon: ElementType }
> = {
  fin_de_bail: { category: CATEGORIES.fin_de_bail, icon: IconLogout },
  resiliation_bail: { category: CATEGORIES.fin_de_bail, icon: IconLogout },
  retard_loyer: { category: CATEGORIES.paiements, icon: IconAlertCircle },
  assurance: { category: CATEGORIES.documents, icon: IconShieldCheck },
  attestation_chauffage: { category: CATEGORIES.documents, icon: IconFlame },
  document_expiration: {
    category: CATEGORIES.documents,
    icon: IconCertificate,
  },
  cautionnement: { category: CATEGORIES.documents, icon: IconSignature },
  revision: { category: CATEGORIES.revisions, icon: IconTrendingUp },
  augmentation_loyer: { category: CATEGORIES.revisions, icon: IconTrendingUp },
  bank_sync: { category: CATEGORIES.banques, icon: IconBuildingBank },
  facture_config: { category: CATEGORIES.documents, icon: IconAlertCircle },
  manual: { category: CATEGORIES.taches, icon: IconChecklist },
};

export function isSnoozed(remindAt: string | null): boolean {
  if (!remindAt) {
    return false;
  }
  return moment(remindAt).isAfter(moment(), "day");
}
